import withDraft from '@/utils/draftHelper';
import actions from '../datasets/constants';
import { updateCollectionDatasetsCount } from './state';

const addDatasetCollectionsList = withDraft((draft, { collection, items }) => {
  updateCollectionDatasetsCount(draft, [collection], items.length);
});

const removeDatasetCollectionsList = withDraft((draft, { collection, items }) => {
  updateCollectionDatasetsCount(draft, [collection], items.length, false);
});

export default {
  [actions.ADD_COLLECTION_DATASETS_SUCCESS]: addDatasetCollectionsList,
  [actions.REMOVE_COLLECTION_DATASETS_SUCCESS]: removeDatasetCollectionsList,
};
